(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bnpl-inline-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('payment-card-rail')) {
    customElements.define('payment-card-rail', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.events?.abort();
        this.observer?.disconnect();
        this.track = this.querySelector('[data-bnpl-cards]');
        if (!this.track) return;
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        this.nav = this.querySelector('.bnpl-payment-rail__nav');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('wheel', () => this.stopMotion(), { ...options, passive: true });
        this.track.addEventListener('keydown', () => this.stopMotion(), options);
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') this.stopMotion();
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.track.scrollWidth <= this.track.clientWidth) return;
          this.suppressClick = false;
          this.stopMotion(true);
          this.track.classList.add('is-settling');
          this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false, lastX: event.clientX, time: performance.now(), velocity: 0, max: this.track.scrollWidth - this.track.clientWidth };
        }, options);
        window.addEventListener('pointermove', (event) => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          const distance = event.clientX - drag.x;
          if (!drag.active) {
            if (Math.abs(distance) < 6) return;
            if (Math.abs(event.clientY - drag.y) > Math.abs(distance)) { this.finishDrag(event); return; }
            drag.active = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(drag.id);
          }
          event.preventDefault();
          const now = performance.now();
          const elapsed = now - drag.time;
          if (elapsed > 0) drag.velocity = .65 * drag.velocity + .35 * (drag.lastX - event.clientX) / elapsed;
          drag.lastX = event.clientX;
          drag.time = now;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const wanted = drag.left - distance;
          const bounded = Math.max(rtl ? -drag.max : 0, Math.min(rtl ? 0 : drag.max, wanted));
          this.track.scrollLeft = bounded;
          const excess = bounded - wanted;
          this.elastic = Math.sign(excess) * 64 * (1 - Math.exp(-Math.abs(excess) / 180));
          this.track.style.transform = `translateX(${this.elastic}px)`;
        }, { ...options, passive: false });
        window.addEventListener('pointerup', (event) => this.finishDrag(event), options);
        window.addEventListener('pointercancel', (event) => this.finishDrag(event), options);
        this.track.addEventListener('lostpointercapture', (event) => this.finishDrag(event), options);
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        document.addEventListener('pointerdown', () => { this.suppressClick = false; }, { ...options, capture: true });
        // Capture before provider widgets or delegated modal handlers receive a drag's click.
        document.addEventListener('click', (event) => {
          if (!this.suppressClick || !this.contains(event.target) || event.detail === 0) return;
          this.suppressClick = false;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { ...options, capture: true });
        this.observer = new ResizeObserver((entries) => {
          const entry = entries.find(entry => entry.target === this.track);
          // The desktop rail is hidden on mobile. Its supplied zero width is
          // sufficient; measuring that hidden subtree can flush pending layout.
          if (!entry || entry.contentRect.width <= 0) return;
          this.update();
        });
        this.observer.observe(this.track);
        // Initial observer delivery follows layout; no synchronous startup measure.
      }
      update() {
        const trackRect = this.track.getBoundingClientRect();
        const image = Array.from(this.track.querySelectorAll('.bnpl-card__payment-image')).find(image => {
          const rect = image.getBoundingClientRect();
          return rect.left >= trackRect.left - 2 && rect.right <= trackRect.right + 2;
        }) || this.track.querySelector('.bnpl-card__payment-image');
        const navTop = image ? (this.track.offsetTop + 4 + image.getBoundingClientRect().height / 2) + 'px' : null;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        // Read the complete track before any CSS/nav-state mutations.
        if (navTop !== null && this.style.getPropertyValue('--payment-nav-top') !== navTop) {
          this.style.setProperty('--payment-nav-top', navTop);
        }
        this.nav.hidden = max < 2;
        this.previous.disabled = offset < 2;
        this.next.disabled = offset >= max - 2;
      }
      move(direction) {
        this.stopMotion();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const offset = Math.abs(this.track.scrollLeft);
        const points = this.snapPoints();
        const target = direction > 0 ? points.find(point => point > offset + 2) : points.reverse().find(point => point < offset - 2);
        if (target == null) return;
        this.track.scrollTo({ left: (rtl ? -1 : 1) * target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      snapPoints() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        let offset = 0;
        const points = Array.from(this.track.querySelectorAll('.bnpl-card')).map(card => {
          const point = Math.min(max, offset);
          offset += card.getBoundingClientRect().width + gap;
          return point;
        });
        return [...new Set([0, ...points, max])];
      }
      finishDrag(event) {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        this.drag = null;
        if (!drag.active) { this.stopMotion(); return; }
        this.suppressClick = true;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
        const card = this.track.querySelector('.bnpl-card');
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const start = this.track.scrollLeft;
        const velocity = !this.elastic && event.type === 'pointerup' && performance.now() - drag.time < 100 ? drag.velocity : 0;
        const projected = Math.max(rtl ? -drag.max : 0, Math.min(rtl ? 0 : drag.max, start + Math.max(-step, Math.min(step, velocity * 160))));
        const target = (rtl ? -1 : 1) * this.snapPoints().reduce((nearest, point) => Math.abs(point - Math.abs(projected)) < Math.abs(nearest - Math.abs(projected)) ? point : nearest, 0);
        const elastic = this.elastic || 0;
        const began = performance.now();
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 360;
        // One animation owns scrolling until it reaches the snap point. Restoring
        // CSS snapping on pointerup would fight this motion and cause a jump.
        const tick = (now) => {
          const progress = duration ? Math.min(1, (now - began) / duration) : 1;
          const remaining = Math.pow(1 - progress, 3);
          this.track.scrollLeft = target + (start - target) * remaining;
          this.track.style.transform = `translateX(${elastic * remaining}px)`;
          if (progress < 1) this.motionFrame = requestAnimationFrame(tick);
          else this.stopMotion();
        };
        this.motionFrame = requestAnimationFrame(tick);
      }
      stopMotion(keepSnapDisabled = false) {
        cancelAnimationFrame(this.motionFrame);
        this.elastic = 0;
        this.track?.style.removeProperty('transform');
        if (!keepSnapDisabled) this.track?.classList.remove('is-settling');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.stopMotion();
        this.track?.classList.remove('is-dragging');
        this.drag = null;
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-info-page"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.info-editorial').forEach((page) => {
    const links = Array.from(page.querySelectorAll('.info-editorial__nav a'));
    const sections = Array.from(page.querySelectorAll('.info-editorial__section[id]'));
    const setActive = (id) => links.forEach((link) => {
      if (link.hash === `#${id}`) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    if (!sections.length) return;
    setActive(sections.find((section) => `#${section.id}` === location.hash)?.id || sections[0].id);
    links.forEach((link) => link.addEventListener('click', () => setActive(link.hash.slice(1))));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) setActive(visible.target.id);
      }, { rootMargin: '-15% 0px -60% 0px' });
      sections.forEach((section) => observer.observe(section));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
